(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 72578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PlainPostCard_PlainPostCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/PlainPostCard/PlainPostCard.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function PlainPostCard({
  post
}) {
  var _post$image, _post$category;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledPicture, _objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)(post === null || post === void 0 ? void 0 : (_post$image = post.image) === null || _post$image === void 0 ? void 0 : _post$image.cover))), /*#__PURE__*/(0,jsx_runtime.jsxs)(Description, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
          children: post === null || post === void 0 ? void 0 : post.name
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubTitle, {
          children: post === null || post === void 0 ? void 0 : post.excerpt
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Category, {
        children: post === null || post === void 0 ? void 0 : (_post$category = post.category) === null || _post$category === void 0 ? void 0 : _post$category.name
      })]
    })
  });
}

/* harmony default export */ var PlainPostCard_PlainPostCard = (PlainPostCard);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Component",
  componentId: "sc-k7pug5-0"
})(["position:relative;"]);
const StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "PlainPostCard__StyledPicture",
  componentId: "sc-k7pug5-1"
})(["width:100%;height:50%;picture,img{width:100%;height:100%;}img{object-fit:cover;height:130px;@media (min-width:1024px){object-fit:cover;}}"]);
const Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Content",
  componentId: "sc-k7pug5-2"
})(["height:290px;border:1px solid ", ";"], theme/* colors.grayProductCard */.O9.grayProductCard);
const Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Description",
  componentId: "sc-k7pug5-3"
})(["padding:10px 16px 40px;height:50%;display:flex;flex-direction:column;justify-content:space-between;"]);
const Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Title",
  componentId: "sc-k7pug5-4"
})(["font-style:normal;font-weight:500;font-size:16px;line-height:24px;@media (min-width:", "){font-size:17px;}overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const SubTitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__SubTitle",
  componentId: "sc-k7pug5-5"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:20px;margin-top:15px;@media (min-width:", "){font-size:13px;}overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;"], theme/* breakpoints.tabletSmall */.AV.tabletSmall);
const Category = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PlainPostCard__Category",
  componentId: "sc-k7pug5-6"
})(["position:absolute;right:0;bottom:0;line-height:30px;font-size:13px;padding:0 20px;background:var(--main-color,#860935);color:", ";&:hover{background:var(--main-color-hover,#6a072a);}"], theme/* colors.white */.O9.white);
;// CONCATENATED MODULE: ./src/components/PlainPostCard/index.ts


/***/ }),

/***/ 50589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ QUERY_DEFAULT_VALUES; }
/* harmony export */ });
const QUERY_DEFAULT_VALUES = {
  PageLimit: 5,
  pageOffset: 0
};

/***/ }),

/***/ 20113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages_blog; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tager/web-components/dist/web-components.esm.js
var web_components_esm = __webpack_require__(63394);
// EXTERNAL MODULE: ./node_modules/@tager/web-core/dist/web-core.esm.js + 6 modules
var web_core_esm = __webpack_require__(61055);
// EXTERNAL MODULE: ./src/utils/thunks.ts
var thunks = __webpack_require__(26625);
// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(41880);
// EXTERNAL MODULE: ./src/store/reducers/tager/blog.ts
var blog = __webpack_require__(44272);
// EXTERNAL MODULE: ./src/store/store.ts + 3 modules
var store = __webpack_require__(11402);
// EXTERNAL MODULE: ./src/pages/_error.tsx
var _error = __webpack_require__(35635);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
// EXTERNAL MODULE: ./src/constants/catalog.ts
var catalog = __webpack_require__(50589);
// EXTERNAL MODULE: ./src/components/Pagination/index.ts + 2 modules
var Pagination = __webpack_require__(89875);
// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
// EXTERNAL MODULE: ./src/components/PlainPostCard/index.ts + 1 modules
var PlainPostCard = __webpack_require__(72578);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/Blog/components/Main/components/Posts/PostsView.tsx









const PostsView = ({
  posts,
  currentPage,
  onPageChange,
  totalPage
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PostsWrapper, {
      children: posts.map(post => /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        to: '/blog/' + post.urlAlias,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlainPostCard/* default */.Z, {
          post: post
        })
      }, post.id))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination/* default */.Z, {
      className: "blog-pagination",
      pageSize: catalog/* QUERY_DEFAULT_VALUES.PageLimit */.q.PageLimit,
      onChange: onPageChange,
      current: currentPage,
      count: totalPage
    })]
  });
};

/* harmony default export */ var Posts_PostsView = (PostsView);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PostsView__Component",
  componentId: "sc-1jjx70u-0"
})(["margin-top:1rem;.blog-pagination{margin-top:1.75rem;}"]);
const PostsWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "PostsView__PostsWrapper",
  componentId: "sc-1jjx70u-1"
})(["display:grid;row-gap:0.5625rem;"]);
;// CONCATENATED MODULE: ./src/modules/Blog/components/Main/components/Posts/Posts.tsx







const Posts = () => {
  const {
    0: currentPage,
    1: setCurrentPage
  } = (0,react.useState)(1);
  const posts = (0,store/* useTypedSelector */.ix)(blog/* selectBlogPostList */.hK);
  const filteredPosts = (0,react.useMemo)(() => {
    if (posts.length > 0) {
      return posts.slice((currentPage - 1) * catalog/* QUERY_DEFAULT_VALUES.PageLimit */.q.PageLimit, catalog/* QUERY_DEFAULT_VALUES.PageLimit */.q.PageLimit * currentPage);
    }

    return [];
  }, [currentPage, posts]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Posts_PostsView, {
    posts: filteredPosts,
    currentPage: currentPage,
    onPageChange: setCurrentPage,
    totalPage: posts.length
  });
};

/* harmony default export */ var Posts_Posts = (Posts);
;// CONCATENATED MODULE: ./src/modules/Blog/components/Main/components/Posts/index.ts

;// CONCATENATED MODULE: ./src/modules/Blog/components/Main/MainView.tsx





const MainView = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MainView_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Posts_Posts, {})
  });
};

/* harmony default export */ var Main_MainView = (MainView);
const MainView_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MainView__Component",
  componentId: "sc-1k4y0xi-0"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Blog/components/Main/Main.tsx




const Main = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Main_MainView, {});
};

/* harmony default export */ var Main_Main = (Main);
;// CONCATENATED MODULE: ./src/modules/Blog/components/Main/index.ts

// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./src/components/BlogSharedHeader/index.ts + 11 modules
var BlogSharedHeader = __webpack_require__(27212);
;// CONCATENATED MODULE: ./src/modules/Blog/components/Top/Top.tsx








const Top = () => {
  const t = (0,production/* useTranslations */.T_)();
  const Title = (0,hooks/* useSettingItem */.qT)('TEXT_BLOG_TITLE');
  const categories = (0,store/* useTypedSelector */.ix)(blog/* selectBlogCategoryList */.FD);
  const breadCrumbList = [];
  breadCrumbList.push({
    url: '/blog',
    label: t('blog.title')
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BlogSharedHeader/* default */.Z, {
    categories: categories,
    pageTitle: Title !== null && Title !== void 0 ? Title : t('blog.title'),
    breadCrumbList: breadCrumbList,
    className: "glossary-navigation"
  });
};

/* harmony default export */ var Top_Top = (Top);
;// CONCATENATED MODULE: ./src/modules/Blog/components/Top/index.ts

;// CONCATENATED MODULE: ./src/modules/Blog/BlogView.tsx








const BlogView = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(BlogView_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Top_Top, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Main_Main, {})]
    })
  });
};

/* harmony default export */ var Blog_BlogView = (BlogView);
const BlogView_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "BlogView__Component",
  componentId: "sc-vlp5e6-0"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Blog/Blog.tsx




const Blog = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Blog_BlogView, {});
};

/* harmony default export */ var Blog_Blog = (Blog);
;// CONCATENATED MODULE: ./src/modules/Blog/index.ts

;// CONCATENATED MODULE: ./src/pages/blog.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function BlogPage(props) {
  const seoParams = (0,store/* useTypedSelector */.ix)(blog/* selectSeoParams */.J);
  const router = (0,next_router.useRouter)();
  const currentPath = (0,common/* getCurrentPath */.b$)(router);
  const canonicalUrl = "https://dverione.com.ua" + currentPath;

  if (props.pageType === 'ErrorPage') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_error["default"], _objectSpread({}, (0,common/* convertErrorToProps */.g1)(props.error)));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(web_components_esm/* Page */.T3, {
    title: seoParams === null || seoParams === void 0 ? void 0 : seoParams.indexPageTitle,
    description: seoParams === null || seoParams === void 0 ? void 0 : seoParams.indexPageDescription,
    canonicalUrl: canonicalUrl,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Blog, {})
    })
  });
}

/* harmony default export */ var pages_blog = (BlogPage);

BlogPage.getInitialProps = async context => {
  const {
    store
  } = context;

  try {
    const requests = Promise.all([...(0,thunks/* getSharedThunkList */.q)(store.dispatch), Promise.all([store.dispatch((0,blog/* getBlogCategoryListThunk */.ao)()), store.dispatch((0,blog/* getSeoParamsThunk */.sZ)())])]);

    if ((0,web_core_esm.isServer)()) {
      await requests;
    }

    return {
      pageType: 'BlogPage'
    };
  } catch (error) {
    return {
      pageType: 'ErrorPage',
      error
    };
  }
};

/***/ }),

/***/ 32912:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(20113);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [741,989,455,880,708,774,888,179], function() { return __webpack_exec__(32912); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);